import { engineComponent, ArrayUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

/**
 * WinAnimator uses paylines and symbols to create presentation of wins to user.
 * Also handle high wins animation for presentation special screens to user when win is bigger than some defined values.
 * @class WinAnimator
 * @extends ContainerElement
 */

@engineComponent(ComponentTypes.DisplayObject)
export class SceneHolderElement extends BaseElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private elementsHolder: Array<Object> = [];

    private hasAdded: boolean;

    private parentContainer: ContainerElement = null;

    private blackList: Array<string>;

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    public updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.hasAttribute(HighWinSceneAttributes.USE_PARENT)) {
            if (this.parentContainer) {
                this.parentContainer.addChild(this);
            }
        }

        this.blackList = [];
        if (node.hasAttribute(HighWinSceneAttributes.BLACK_LIST)) {
            this.blackList = ArrayUtils.stringArray(node.getAttribute(HighWinSceneAttributes.BLACK_LIST));
        }

        if (node.hasAttribute(HighWinSceneAttributes.ADD_CHILDS)) {
            this.addChildsToElement();
        }

        if (node.hasAttribute(HighWinSceneAttributes.RETURN_CHILDS)) {
            this.addChildsToOriginalParent();
        }
    }

    private addChildsToElement(): void {
        if (!this.hasAdded) {
            for (let i = 0; i < this.elementsHolder.length; i++) {
                let elem = this.elementsHolder[i];

                if (elem != null) {
                    if (this.blackList.indexOf(elem["element"]["name"]) == -1) {
                        this.addChild(elem["element"]);
                    }
                }
            }

            this.hasAdded = true;
        }
    }

    //******************************************************************************************************************
    //  STATIC
    //******************************************************************************************************************

    public addElement(elem: Object): void {
        this.elementsHolder.push(elem);
    }

    public addChildsToOriginalParent(): void {
        if (this.hasAdded) {
            for (let i = 0; i < this.elementsHolder.length; i++) {
                let elem = this.elementsHolder[i];

                if (elem != null) {
                    let origElement = <BaseElement>elem["parent"];
                    let element = <BaseElement>elem["element"];

                    origElement.addChildAt(element, elem["index"]);
                }
            }

            this.hasAdded = false;
        }
    }

    public setHolderParent(elem: ContainerElement): void {
        this.parentContainer = elem;
    }
}

export const HighWinSceneAttributes = {
    ADD_CHILDS: "AddChilds",
    BLACK_LIST: "BlackList",
    RETURN_CHILDS: "ReturnChilds",
    USE_PARENT: "UseParent",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SceneHolderElement.ts
 **/